import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { ICancelReason } from './typings'
import { getAllCancelReasons } from './api'

const cancelReasonsAdapter = createEntityAdapter<ICancelReason>({})

export const initialState = cancelReasonsAdapter.getInitialState()

const cancelReasons = createSlice({
  name: 'cancelReasons',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCancelReasons.fulfilled, (state, { payload }) => {
      cancelReasonsAdapter.setAll(state, payload)
    })
  },
})

export default cancelReasons.reducer

const selectors = cancelReasonsAdapter.getSelectors<StoreData>(
  (state) => state.cancelReasons,
)

export const { selectAll: selectAllCancelReasons } = selectors
